import { useMemo } from 'react';

import { CampaignStatus } from 'utils/constants/dashboard';

import { useSelector } from 'store/utils';

interface CheckedCampaignIdsForBudgetResult {
    infinityBudgetCampaignsCount: number;
    stoppedByEndDateCampaignsCount: number;
    availableCampaignIdsForBudget: Record<number, boolean>;
}

const useCheckedCampaignIdsForBudget = (): CheckedCampaignIdsForBudgetResult => {
    const checkedCampaignIds = useSelector((state) => state.dashboard.checkedCampaignIds);
    const campaigns = useSelector((state) => state.dashboard.campaigns);

    const { infinityBudgetCampaignsCount, stoppedByEndDateCampaignsCount, availableCampaignIdsForBudget } =
        useMemo(() => {
            let infinityBudgetCampaignsCount = 0;
            let stoppedByEndDateCampaignsCount = 0;
            const availableCampaignIdsForBudget: Record<number, boolean> = {};

            const checkedIdsSet = new Set(Object.keys(checkedCampaignIds).map(Number));

            campaigns.forEach((campaign) => {
                if (!checkedIdsSet.has(campaign.id)) return;

                if (campaign.budget === null) {
                    infinityBudgetCampaignsCount += 1;
                } else if (campaign.frontendStatus === CampaignStatus.InactiveDueToEndDate) {
                    stoppedByEndDateCampaignsCount += 1;
                } else {
                    availableCampaignIdsForBudget[campaign.id] = true;
                }
            });

            return {
                infinityBudgetCampaignsCount,
                stoppedByEndDateCampaignsCount,
                availableCampaignIdsForBudget,
            };
        }, [checkedCampaignIds, campaigns]);

    return { infinityBudgetCampaignsCount, stoppedByEndDateCampaignsCount, availableCampaignIdsForBudget };
};

export default useCheckedCampaignIdsForBudget;
